import { Button } from '@material-ui/core'
import React from 'react'
import './login.css'
import {auth,provider} from  './firebase'
import {useStateValue} from './StateProvider'
import {actionTypes } from './reducer'

function Login() {
    const[{},dispatch] = useStateValue();
    const SignIn = (e)=>{
        e.preventDefault();
        auth.signInWithPopup(provider)
        .then((result) =>{
          dispatch({
            type: actionTypes.SET_USER,
            user: result.user,
          })
        } )
        .catch(error => alert(error.message));
    }
  return (
    <div className='login'>
      <div className='login_container'>
        <img src='https://download.logo.wine/logo/WhatsApp/WhatsApp-Logo.wine.png' alt='WHATSAPP'/>
         <div className='login_text'>
          <h1>Sign In with Google</h1>
         </div>
         <Button type="submit" onClick={SignIn}>
            Sign In
         </Button>
      </div>

    </div>
  )
}

export default Login